import React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
`;

export const Asterisk = styled.span`
  font-size: ${rem('12.8px')};
  vertical-align: text-top;
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: ${rem('12.8px')};
  width: 90%;
  max-width: ${rem('640px')};
  border-radius: ${rem('8px')};
  max-height: calc(80vh - ${rem('64px')});
  position: relative;
  overflow-y: auto;
  padding-bottom: ${rem('20px')};
`;

export const ModalHeader = styled.div`
  margin-bottom: ${rem('24px')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;

export const ModalHeaderContent = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: ${rem('20px')};
  font-weight: 600;
  margin: 0 0 ${rem('8px')} 0;
  color: #333;
`;

export const ModalSubtitle = styled.p`
  font-size: ${rem('14px')};
  color: #666;
  margin: 0;
  font-weight: 400;
`;

export const CloseButton = styled.button`
  color: gray;
  background: none;
  padding: 0 ${rem('6.4px')};
  border: none;
  font-size: ${rem('24px')};
  cursor: pointer;
  color: gray;

  &:hover {
    color: #ff0000;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${rem('9.6px')};

  @media (max-width: 450px) {
    display: flex;
    flex-direction: column;
  }
`;

export const InputDiv = styled.div`
  width: 100%;
`;

export const InputDivWide = styled.div`
  grid-column: span 2;
  width: 100%;
`;

export const Input = styled.input`
  padding: ${rem('8px')};
  width: 100%;
  margin-bottom: ${rem('16px')};
  border: ${rem('1px')} solid #ddd;
  border-radius: ${rem('4px')};
`;

export const ErrorInput = styled(Input)`
  border: ${rem('1px')} solid red;
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: ${rem('12.8px')};
  margin-top: ${rem('-16px')};
  margin-bottom: 0;
  display: block;
`;

export const Select = styled.select`
  padding: ${rem('8px')};
  width: 100%;
  margin-bottom: ${rem('16px')};
  border: ${rem('1px')} solid #ddd;
  border-radius: ${rem('4px')};
  appearance: none;
  background: white;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="gray" d="M7 10l5 5 5-5H7z"/></svg>'); /* Custom arrow */
  background-repeat: no-repeat;
  background-position: right ${rem('10px')} center;
  background-size: ${rem('16px')};
`;

export const FullWidthInput = styled(Input)<{ error?: boolean }>`
  grid-column: span 2;
  border: ${rem('1px')} solid ${({ error }) => (error ? 'red' : '#ccc')};
`;

export const ButtonCancel = styled.button`
  padding: ${rem('10px')} ${rem('20px')};
  margin: ${rem('5px')};
  border: ${rem('1px')} solid gray;
  border-radius: ${rem('4px')};
  cursor: pointer;
`;

export const Buttons = styled.div`
  display: flex;
  gap: ${rem('16px')};
  justify-content: flex-end;
  align-items: center;
  width: 90%;
  max-width: ${rem('640px')};
  position: sticky;
  bottom: 10%;
  background-color: white;
  border-top: ${rem('1px')} solid #e0e0e0;
  padding: ${rem('16px')} ${rem('24px')};
  z-index: 10;

  @media (max-width: 450px) {
    flex-direction: column-reverse;
    bottom: 8%;
  }
`;

export const SaveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${rem('8px')};
  padding: ${rem('12px')} ${rem('32px')};
  font-size: ${rem('14px')};
  font-weight: 600;
  color: #fff;
  background-color: #e60000;
  border: ${rem('2px')} solid #e60000;
  border-radius: ${rem('4px')};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: ${rem('140px')};

  &:hover:not(:disabled) {
    background-color: #cc0000;
    border-color: #cc0000;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: ${rem('16px')};
    height: ${rem('16px')};
  }
`;

export const CancelButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${rem('8px')};
  padding: ${rem('12px')} ${rem('32px')};
  font-size: ${rem('14px')};
  font-weight: 600;
  color: #333;
  background-color: #fff;
  border: ${rem('2px')} solid #ddd;
  border-radius: ${rem('4px')};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: ${rem('140px')};

  &:hover:not(:disabled) {
    background-color: #f5f5f5;
    border-color: #ccc;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${rem('8px')};
  grid-column: span 2;
  padding-left: ${rem('4px')};
  width: 50%;
  font-size: ${rem('14px')};
  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const UnderlinedText = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

// MCA Form Styles
export const SectionDivider = styled.div`
  margin: ${rem('32px')} 0 ${rem('24px')} 0;
  padding-top: ${rem('24px')};
  border-top: ${rem('2px')} solid #e60000;
`;

export const SectionTitle = styled.h3`
  font-size: ${rem('20px')};
  margin: 0 0 ${rem('8px')} 0;
  color: #000;
`;

export const SectionDescription = styled.p`
  font-size: ${rem('18px')};
  margin: 0 0 ${rem('16px')} 0;
  line-height: 1.5;
`;

export const SectionBoldTitle = styled.h3`
  font-size: ${rem('20px')};
  margin: 0 0 ${rem('8px')} 0;
  color: #000;
  font-weight: 600;
`;

export const ProgressIndicator = styled.div`
  display: none; // Hidden as per new design
`;

export const StepCircle = styled.div<{ $active?: boolean; $completed?: boolean }>`
  display: none; // Hidden as per new design
`;

export const StepLine = styled.div<{ $completed?: boolean }>`
  display: none; // Hidden as per new design
`;

// New Timeline Styles
export const TimelineContainer = styled.div<{ needsMCA?: boolean }>`
  position: relative;
  padding-left: 0;

  ${({ needsMCA }) =>
    needsMCA &&
    css`
      padding-left: ${rem('40px')};
    `}
`;

export const TimelineStep = styled.div<{noPaddingBottom?: boolean}>`
  position: relative;
  padding-bottom: ${({ noPaddingBottom }) => (noPaddingBottom ? '0' : rem('32px'))};

  &:last-child {
    padding-bottom: 0;
  }
`;

export const TimelineDot = styled.div`
  position: absolute;
  left: ${rem('-37px')};
  top: ${rem('10px')};
  width: ${rem('20px')};
  height: ${rem('20px')};
  border-radius: 50%;
  background-color: #e60000;
  z-index: 3;
`;

export const TimelineDotAdditionalInformation = styled.div`
  position: absolute;
  width: ${rem('22px')};
  height: ${rem('22px')};
  left: ${rem('-37px')};
  margin-top: ${rem('4px')};
  border-radius: 50%;
  background-color: #e60000;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #e60000; /* Cria um segundo anel vermelho */
  z-index: 3;
`;

export const TimelineLine = styled.div`
  position: absolute;
  left: ${rem('-28px')};
  top: ${rem('28px')};
  width: ${rem('2px')};
  background-color: #e60000;
  z-index: 1;
`;

export const TimelineLineExtended = styled(TimelineLine)`
  /* Extends through Step 2 to reach Step 3 dot
     The line starts at top: 28px (after the first dot)
     It needs to extend through:
     - Step 1 remaining content
     - Step 1 padding-bottom: 32px
     - Step 2 full content + padding: 32px
     - Until Step 3 dot position (top: 4px)
     Using a large enough height to cover all steps */
  height: ${rem('1080px')};
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: ${rem('870px')};
  }
  @media only screen and (min-width: 450px) {
    height: ${rem('870px')};
  }
`;

export const StepContent = styled.div`
  position: relative;
`;

export const InfoMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${rem('12px')};
  padding: ${rem('12px')};
  background-color: #e6f2ff;
  border-left: ${rem('4px')} solid #0066cc;
  border-radius: ${rem('4px')};
  font-size: ${rem('14px')};
  color: #333;
  grid-column: span 2;
  margin-top: ${rem('8px')};

  svg {
    flex-shrink: 0;
    margin-top: ${rem('2px')};
  }
`;

export const EmailInfoMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('8px')};
  font-size: ${rem('14px')};
  span {
    font-size: ${rem('14px')};
  }

  svg {
    flex-shrink: 0;
  }
`;

export const AgreementSection = styled.div``;

export const AgreementTitle = styled.h4`
  font-size: ${rem('20px')};
  color: #000;
`;

export const AgreementText = styled.p`
  font-size: ${rem('18px')};
  line-height: 1.5;
  margin: 0 0 ${rem('16px')} 0;
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const InfoBox = styled.div<{ $type: 'info' | 'success' | 'warning' | 'error' }>`
  display: flex;
  align-items: flex-start;
  gap: ${rem('12px')};

  border-radius: ${rem('4px')};
  font-size: ${rem('14px')};
`;

export const MCAInfoText = styled.p`
  font-size: ${rem('18px')};
  margin: 0 0 ${rem('32px')} 0;
  line-height: 1.5;
`;
